import {
    merge
} from './../../../tool/util';
export default {
    data() {
        let cacheData = {
            echart: null,
        };
        return {
            getCacheData() {
                return cacheData;
            }
        };
    },
    methods: {
        getEcharts() {
            return this.getCacheData().echart;
        },

        /**  
         * 设置echarts 图层列表
         */
        setEchartLayers(layers = []) {
            let myEchart = this.getCacheData().echart;
            const mapConfig = {
                bmap: {
                    center: this.config.center,
                    zoom: this.config.zoom.value,
                    // roam: 'move'
                }
            };
            let option = merge(myEchart.getOption(), mapConfig);
            let series = [];
            layers.forEach((element) => {
                let serieString = element.toString();
                if (Array.isArray(serieString)) {
                    serieString.forEach((item) => {
                        item.coordinateSystem = this.coordinateSystem;
                        series.push(item);
                    });
                } else {
                    serieString.coordinateSystem = this.coordinateSystem;
                    series.push(serieString);
                }

            });
            // console.log(JSON.stringify(series));
            option.series = series;

            myEchart.setOption(option, {
                notMerge: false,
                lazyUpdate: false
            });
            
        },

    },
    mounted() {

    }
};